export default {
  title: 'Importen er i gang... 🙂',
  description: 'Der sendes Slack-notifikationer, når importen er færdig.',
  buttons: {
    open_followers_list: 'Åbn følgerliste',
  },
};
